import React, { Suspense, useContext } from 'react';
import UserContext from '../contexts/UserContext';
import SideBar from '../components/Sidebar/SideBar';
import { LinearProgress } from '@mui/material';

function Layout({ children }) {
  const { isAuthenticated } = useContext(UserContext);

  return (
    <>
      <Suspense fallback={<LinearProgress />}>
        {isAuthenticated && <SideBar />}
        {children}
      </Suspense>
    </>
  );
}

export default Layout;
